import styled from '@emotion/styled';

const Td = styled.td(props => ({
  width: '36px',
}))

export default Td;
